const APP_FIELDS = ['id', 'name', 'description', 'website', 'icon'];
const INSTALLED_APP_FIELDS = ['id', 'name', 'appId', 'externalEntityId', 'entityType', 'entityId', 'context.locationId', 'context.businessId'];

class AppRepo {
  constructor(client, id, parentContext) {
    this.client = client;
    this.id = id;
    this.context = parentContext;
  }

  details() {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const installedAppId = this.id;
    const path = propertyId ? `/properties/${propertyId}/apps/installs/${installedAppId}` : `/businesses/${businessId}/apps/installs/${installedAppId}`;
    const req = new this.client.Request(path, {}, propertyId ? APP_FIELDS : INSTALLED_APP_FIELDS);
    return this.client.get(req);
  }

  uninstall() {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const installedAppId = this.id;
    const path = propertyId ? `/properties/${propertyId}/apps/installs/${installedAppId}/uninstall` : `/businesses/${businessId}/apps/installs/${installedAppId}/uninstall`;
    const req = new this.client.Request(path);
    return this.client.post(req);
  }

}

class AppsRepo {
  constructor(client, parentContext) {
    this.client = client;
    this.context = parentContext;

    this.for = id => new AppRepo(client, id, this.context);
  }

  install({
    appId,
    name,
    context
  }) {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/apps/installs` : `/businesses/${businessId}/apps/installs`;
    const req = new this.client.Request(path, {
      appId,
      name,
      context
    }, INSTALLED_APP_FIELDS);
    return this.client.post(req);
  }

  listBusinessApps() {
    const path = '/businesses/apps';
    const req = new this.client.Request(path, undefined, APP_FIELDS);
    return this.client.get(req);
  }

  listPropertyApps() {
    const path = '/properties/apps';
    const req = new this.client.Request(path, undefined, APP_FIELDS);
    return this.client.get(req);
  }

  listInstalledApps() {
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    const path = propertyId ? `/properties/${propertyId}/apps/installs` : `/businesses/${businessId}/apps/installs`;
    const req = new this.client.Request(path, undefined, INSTALLED_APP_FIELDS);
    return this.client.get(req);
  }

}

module.exports = AppsRepo;